import script from "./ArticleModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ArticleModal.vue?vue&type=script&setup=true&lang=ts"

import "./ArticleModal.vue?vue&type=style&index=0&id=fad50da4&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fad50da4"]])

export default __exports__